import React from 'react';
import {
  BedOutline,
  CalendarOutline,
  DocumentTextOutline,
  HeartOutline,
  HelpCircleOutline,
  HomeOutline,
  InformationCircleOutline,
  MedalOutline,
  PersonOutline,
  RibbonOutline,
  StorefrontOutline,
} from 'react-ionicons';

import { FILLS } from '../../styles/tokens';

export interface MenuItem {
  text: string;
  icon: (size?: string, color?: string) => React.ReactElement;
  path: string;
  external?: boolean;
  hash?: string;
  state?: Record<string, any>;
  requiresStateMatch?: boolean;
  /**
   * Optional override for how the item's label renders. When present,
   * consumers render this instead of the plain `text` string — used to
   * style part of the label (e.g. a gold-highlighted character) without
   * changing the accessible name, which is still derived from `text`.
   */
  renderLabel?: () => React.ReactNode;
}

export const discoverMenuItem: MenuItem = {
  text: 'Discover',
  icon: (size = '20px', color = FILLS.textPrimary) => (
    <HomeOutline width={size} height={size} color={color} />
  ),
  path: '/',
};
export const accommodationMenuItem: MenuItem = {
  text: 'Accommodation',
  icon: (size = '20px', color = FILLS.textPrimary) => (
    <BedOutline width={size} height={size} color={color} />
  ),
  path: '/accommodations',
};
export const servicesMenuItem: MenuItem = {
  text: 'Services',
  icon: (size = '20px', color = FILLS.textPrimary) => (
    <RibbonOutline width={size} height={size} color={color} />
  ),
  path: '/services',
};
export const wishlistMenuItem: MenuItem = {
  text: 'Wishlist',
  icon: (size = '20px', color = FILLS.textPrimary) => (
    <HeartOutline width={size} height={size} color={color} />
  ),
  path: '/wishlist',
};

export const bookingsMenuItem: MenuItem = {
  text: 'Bookings',
  icon: (size = '20px', color = FILLS.textPrimary) => (
    <CalendarOutline width={size} height={size} color={color} />
  ),
  path: '/bookings',
};

export const requestsMenuItem: MenuItem = {
  text: 'Requests',
  icon: (size = '20px', color = FILLS.textPrimary) => (
    <DocumentTextOutline width={size} height={size} color={color} />
  ),
  path: '/requests',
};

export const adminPanelMenuItem: MenuItem = {
  text: 'Admin Panel',
  icon: (size = '20px', color = FILLS.textPrimary) => (
    <StorefrontOutline width={size} height={size} color={color} />
  ),
  path: '/admin',
};

export const userProfileMenuItem = (_userFirstName: string): MenuItem => {
  return {
    text: 'Profile',
    icon: (size = '20px', color = FILLS.textPrimary) => (
      <PersonOutline width={size} height={size} color={color} />
    ),
    path: '/profile',
  };
};

export const conciergeEnquiryMenuItem: MenuItem = {
  text: 'Concierge',
  icon: (size = '20px', color = FILLS.textPrimary) => (
    <HelpCircleOutline width={size} height={size} color={color} />
  ),
  path: '/concierge-enquiry',
};

export const aboutMenuItem: MenuItem = {
  text: 'About',
  icon: (size = '20px', color = FILLS.textPrimary) => (
    <InformationCircleOutline width={size} height={size} color={color} />
  ),
  path: '/about',
};

export const belhopPlusMenuItem: MenuItem = {
  text: 'Belhop+',
  icon: (size = '20px', color = FILLS.textPrimary) => (
    <MedalOutline width={size} height={size} color={color} />
  ),
  path: '/belhop-plus',
  renderLabel: () => (
    <>
      Belhop
      {/* Bold as well as gold, so the "+" pops in the tab (owner request) —
          still a single character in text/linework gold, not a second
          solid-gold fill, so the One Lamp rule holds. */}
      <span style={{ color: FILLS.gold, fontWeight: 700 }}>+</span>
    </>
  ),
};
